import React from 'react'
import Badge from '@/admin/shared/components/Badge/Badge'
import { CellMono } from '@/admin/shared/components/DataTable/Cell'
import type { DataTableColumn } from '@/admin/shared/components/DataTable/DataTable'
import type { Subscription } from '../types'

export const COLUMNS: DataTableColumn<Subscription>[] = [
  {
    key: 'email',
    label: 'Email',
    render: s => <CellMono>{s.email}</CellMono>,
  },
  {
    key: 'status',
    label: 'Status',
    render: s => {
      if (s.unsubscribed_at) return <Badge variant="muted" dot>Unsubscribed</Badge>
      if (s.subscribed_at)   return <Badge variant="success" dot>Active</Badge>
      return <Badge variant="warning" dot>Pending</Badge>
    },
  },
  {
    key: 'subscribed_at',
    label: 'Subscribed',
    sortable: true,
    render: s => s.subscribed_at
      ? <CellMono>{new Date(s.subscribed_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</CellMono>
      : <span style={{ color: 'var(--t-light)', fontSize: 12 }}>—</span>,
  },
  {
    key: 'created_at',
    label: 'Joined',
    render: s => (
      <CellMono>
        {new Date(s.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
      </CellMono>
    ),
  },
]
